import React, { useState } from "react";
import {
  View,
  Text,
  Image,
  Dimensions,
  Animated,
  TouchableOpacity,
  StyleSheet,
  ScrollView,
  FlatList,
  TextInput,
} from "react-native";
const { width, height } = Dimensions.get("window");
export default function prelimDetail({
  approbation_details,
  events_female,
  events_male,
}) {
  console.log(approbation_details);
  const result = Object.keys(approbation_details.events_male).map((key) => {
    return { name: key, NumLength: approbation_details.events_male[key] };
  });

  const result2 = Object.keys(approbation_details.events_female).map((key) => {
    return { name: key, NumLength: approbation_details.events_female[key] };
  });

  console.log("approbation_details ", approbation_details.room_requests);

  return (
    <View>
      <Text
        style={width >= 1280 ? styles.textTitle : stylesResponsive.textTitle}
      >
        PRELIMINARY ENTRY SUBMIT
      </Text>
      <View style={{ flexDirection: "row" }}>
        <View style={{ width: width * 0.25 }}>
          <Text
            style={[
              width >= 1280 ? styles.textTitle : stylesResponsive.textTitle,
              { marginTop: 20 },
            ]}
          >
            ATHLETE
          </Text>
          <Text
            style={[
              width >= 1280 ? styles.textDetail : stylesResponsive.textDetail,
              { marginTop: 10 },
            ]}
          >
            MALE
          </Text>
          <Text style={styles.textNumber}>
            {approbation_details.athlete_male_numbers}
          </Text>
          <Text
            style={
              width >= 1280 ? styles.textDetail : stylesResponsive.textDetail
            }
          >
            FEMALE
          </Text>
          <Text style={styles.textNumber}>
            {approbation_details.athlete_female_numbers}
          </Text>
          <Text
            style={
              width >= 1280 ? styles.textTitle : stylesResponsive.textTitle
            }
          >
            OFFICIAL
          </Text>
          <Text
            style={
              width >= 1280 ? styles.textDetail : stylesResponsive.textDetail
            }
          >
            MALE
          </Text>
          <Text style={styles.textNumber}>
            {approbation_details.official_male_numbers}
          </Text>
          <Text
            style={
              width >= 1280 ? styles.textDetail : stylesResponsive.textDetail
            }
          >
            FEMALE
          </Text>
          <Text style={styles.textNumber}>
            {approbation_details.official_female_numbers}
          </Text>
        </View>
        <View>
          <Text
            style={[
              width >= 1280 ? styles.textTitle : stylesResponsive.textTitle,
              { marginTop: 20 },
            ]}
          >
            ROOM REQUEST
          </Text>
          {approbation_details.room_requests.single != undefined && (
            <Text
              style={[
                width >= 1280 ? styles.textDetail : stylesResponsive.textDetail,
                { marginTop: 10 },
              ]}
            >
              SINGLE BEDDED ROOM
            </Text>
          )}
          {approbation_details.room_requests.single != undefined && (
            <Text style={styles.textNumber}>
              {approbation_details.room_requests.single}
            </Text>
          )}
          {approbation_details.room_requests.twin != undefined && (
            <Text
              style={
                width >= 1280 ? styles.textDetail : stylesResponsive.textDetail
              }
            >
              TWIN BEDDED ROOM
            </Text>
          )}
          {approbation_details.room_requests.twin != undefined && (
            <Text style={styles.textNumber}>
              {approbation_details.room_requests.twin}
            </Text>
          )}
          {approbation_details.room_requests.tripple != undefined && (
            <Text
              style={
                width >= 1280 ? styles.textDetail : stylesResponsive.textDetail
              }
            >
              TRIPPLE BEDDED ROOM
            </Text>
          )}
          {approbation_details.room_requests.tripple != undefined && (
            <Text style={styles.textNumber}>
              {approbation_details.room_requests.tripple}
            </Text>
          )}
          {approbation_details.room_requests.quad != undefined && (
            <Text
              style={
                width >= 1280 ? styles.textDetail : stylesResponsive.textDetail
              }
            >
              QUADRUBLE BEDDED ROOM
            </Text>
          )}
          {approbation_details.room_requests.quad != undefined && (
            <Text style={styles.textNumber}>
              {approbation_details.room_requests.quad}
            </Text>
          )}
        </View>
      </View>
      <Text
        style={[
          width >= 1280 ? styles.textTitle : stylesResponsive.textTitle,
          { fontSize: 22, marginTop: 20 },
        ]}
      >
        EVENTS
      </Text>
      <Text
        style={[
          width >= 1280 ? styles.textDetail : stylesResponsive.textDetail,
          { marginVertical: 10 },
        ]}
      >
        MALE
      </Text>
      <FlatList
        data={result}
        numColumns={width >= 1280 ? 4 : 2}
        renderItem={({ item, index }) => {
          console.log(item);
          return (
            <View style={{ flexDirection: "row" }}>
              <Text
                style={
                  width >= 1280
                    ? styles.textDetail
                    : stylesResponsive.textDetail
                }
              >
                {item.name + " : " + item.NumLength}
              </Text>
              <Text
                style={[
                  width >= 1280
                    ? styles.textDetail
                    : stylesResponsive.textDetail,
                  width >= 1280
                    ? styles.detailNumber
                    : stylesResponsive.detailNumber,
                ]}
              >
                {/* {item.NumLength} */}
              </Text>
            </View>
          );
        }}
      />
      <Text
        style={[
          width >= 1280 ? styles.textDetail : stylesResponsive.textDetail,
          { marginVertical: 10 },
        ]}
      >
        FEMALE
      </Text>
      <FlatList
        data={result2}
        numColumns={width >= 1280 ? 4 : 2}
        renderItem={({ item, index }) => {
          // var keys = Object.keys(item);
          // console.log(keys[index]);

          console.log("result2 >> ", result2, item);

          return (
            <View style={{ flexDirection: "row" }}>
              <Text
                style={
                  width >= 1280
                    ? styles.textDetail
                    : stylesResponsive.textDetail
                }
              >
                {item.name + " : " + item.NumLength}
              </Text>
              <Text
                style={[
                  width >= 1280
                    ? styles.textDetail
                    : stylesResponsive.textDetail,
                  width >= 1280
                    ? styles.detailNumber
                    : stylesResponsive.detailNumber,
                ]}
              >
                {/* {item.number == "" ? "0" : item.number} */}
              </Text>
            </View>
          );
        }}
      />
    </View>
  );
}
const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#CCE4FF",
    flexDirection: "row",
  },
  textTitle: {
    fontSize: 20,
    fontFamily: "Prompt",
    color: "#2B6AB1",
  },
  textDetail: {
    fontSize: 16,
    fontFamily: "Prompt",
    color: "#2B6AB1",
  },
  detailNumber: {
    marginHorizontal: width * 0.05,
    width: width * 0.015,
    textAlign: "center",
  },
  textNumber: {
    fontSize: 16,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    marginLeft: 10,
  },
});
const stylesResponsive = StyleSheet.create({
  textTitle: {
    fontSize: 16,
    fontFamily: "Prompt",
    color: "#2B6AB1",
  },
  textDetail: {
    fontSize: 14,
    fontFamily: "Prompt",
    color: "#2B6AB1",
  },
  detailNumber: {
    marginHorizontal: width * 0.05,
    width: width * 0.08,
    textAlign: "center",
  },
});
